import { render } from "./IconSquareLight.vue?vue&type=template&id=797e7f66"
const script = {}

import exportComponent from "/var/www/prod/fe/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__